<template>
    <div class="row">
        <div class="col-12 col-lg-10 algolia-listing-product-block__image__info-wrapper">
            <div class="algolia-listing-product-block__image-wrapper">
                <img
                    :src="src"
                    :alt="alt"
                    class="algolia-listing-product-block__image"
                    itemprop="image"
                />
            </div>
            <ProductImageAlertLabel
                :alert-label="alertLabel"
                v-if="alertLabel"
            />
        </div>
    </div>
</template>

<script>
import ProductImageActionLabel from "./ProductImageActionLabel";
import ProductImageAlertLabel from "./ProductImageAlertLabel";

export default {
    name: "ProductImage",
    components: {
        ProductImageActionLabel,
        ProductImageAlertLabel
    },
    props: {
        alertLabel: {
            type: [Boolean, String],
            required: false
        },
        productUrl: {
            type: String,
            required: true
        },
        src: {
            type: String,
            default: ""
        },
        alt: {
            type: String,
            default: "Product image"
        }
    }
};
</script>
